import React from 'react';
import PurchaseOrdersSection from './project-sections/PurchaseOrdersSection';
import { useOutletContext } from 'react-router-dom';

export default function PurchaseOrdersPage() {
  const outletContext = useOutletContext();
  const projectId = outletContext?.projectId;
  const project = outletContext?.project;

  return (
    <div className="po-wide">
      <PurchaseOrdersSection projectId={projectId} project={project} />
    </div>
  );
}
